module.exports = __webpack_public_path__ + "img/9788970129464.cc9fb552.jpg";